<template lang="pug">
div
    //- list of counted stock
    .box
        .box-header
            h3 Stocks to Return
            small Stock quantity will be deducted when mark as shipped

        //- form to validate stock quantity
        form
            v-client-table(
                :data="stocks",
                :columns="columns",
                :options="options",
                ref="datatable",
            )
                template(slot="return_quantity" slot-scope="props")
                    div(v-if="canEdit")
                        input.w-sm.form-control(
                            :class="{ 'has-error': errors.has('return quantity', `return_quantity_${props.row.stock_id}`) }",
                            type="text",
                            name="return quantity",
                            autocomplete="off",
                            placeholder="Enter Qty",
                            v-validate="`required|decimal:2|min_value:0|max_value:${props.row.current_quantity}`",
                            :data-vv-scope="`return_quantity_${props.row.stock_id}`",
                            :id="`return_quantity_${props.row.stock_id}`",
                            :key="`return_quantity_${props.row.stock_id}`",
                            @input="updateReturnStock({stock_id: props.row.stock_id, key: 'return_quantity', value: $event.target.value})",
                            :value="props.row.return_quantity"
                        )
                        span.text-danger(v-if="errors.has('return quantity', `return_quantity_${props.row.stock_id}`)")
                            | {{ errors.first('return quantity', `return_quantity_${props.row.stock_id}`) }}

                    span(v-else) {{ props.row.return_quantity  }}

                template(slot="price" slot-scope="props")
                    div(v-if="canEdit")
                        input.w-sm.form-control(
                            :class="{ 'has-error': errors.has('price', `price_${props.row.stock_id}`) }",
                            type="text",
                            name="price",
                            autocomplete="off",
                            placeholder="Enter Price",
                            v-validate="'required|decimal:2|min_value:0'",
                            :data-vv-scope="`price_${props.row.stock_id}`",
                            :id="`price_${props.row.stock_id}`",
                            :key="`price_${props.row.stock_id}`",
                            @input="updateReturnStock({stock_id: props.row.stock_id, key: 'price', value: $event.target.value})",
                            :value="props.row.price"
                        )
                        span.text-danger(v-if="errors.has('price', `price_${props.row.stock_id}`)")
                            | {{ errors.first('price', `price_${props.row.stock_id}`) }}

                    span(v-else) {{ formattedNumber(props.row.price)  }}

                template(slot="total" slot-scope="props")
                    span {{ total(props.row) }}

                template(slot="action", slot-scope="props")
                    button.md-btn.md-flat.m-b-sm.btn-xs.text-muted(
                        v-show="canEdit",
                        type="button",
                        @click="removeReturnStock(props.row.stock_id)"
                    )
                        i.material-icons delete
                </button>

                template(slot="appendBody")
                    tr
                        td.text-right._500(:colspan="colspan") Total
                        td.text-center._500 {{ formattedNumber(totalPrice) }}
                        td(v-if="canEdit")
                
                template(slot="afterTable")
                    .row.p-a(v-if="canEdit")
                        .col-md-6.col-md-offset-6
                            .form-group
                                label.m-b-0._500 Select Stock to Return
                                stock-inventory-selector(
                                    placeholder="Select stock",
                                    :outlet-id="stockReturn.outlet_id",
                                    @select="onSelectStock"
                                )
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import stockReturnMixin from './stock-return-mixin';

export default {
    inject: ['$validator'],

    mixins: [stockReturnMixin],

    data() {
        return {
            checkedAll: false,
            options: {
                filterable: false,
                sortable: [],
                perPage: 1000,
                perPageValues: [1000],
                headings: {
                    price: 'Supplier Price',
                    return_quantity: 'Return Qty',
                    current_quantity: 'Current Qty',
                    action: '',
                },
                columnsClasses: {
                    action: 'w-xs',
                    current_quantity: 'w-sm text-center',
                    return_quantity: 'w-sm text-center',
                    price: 'w-sm text-center',
                    total: 'text-nowrap w-sm text-center',
                },
                templates: {
                    name: (h, row) => {
                        return row.stock.name;
                    },
                    sku: (h, row) => {
                        return row.stock.sku;
                    },
                    barcode: (h, row) => {
                        return row.stock.barcode;
                    },
                },
                skin: 'table m-b-0 b-b',
                uniqueKey: 'stock_id',
            },
        };
    },

    computed: {
        ...mapGetters('stockReturn', [
            'stockReturn',
            'stocks',
            'findStockIndex',
            'totalPrice',
        ]),

        columns() {
            let columns = [
                'name',
                'sku',
                'barcode',
                'current_quantity',
                'return_quantity',
                'price',
                'total',
                'action',
            ];

            if (!this.canEdit) {
                columns = columns.filter(c => c !== 'action');
            }

            if (this.hasFinalized) {
                columns = columns.filter(c => c !== 'current_quantity');
            }

            return columns;
        },

        colspan() {
            if (this.hasFinalized) return 5;
            return 6;
        },
    },

    methods: {
        ...mapActions('stockReturn', [
            'removeReturnStock',
            'addReturnStock',
            'updateReturnStock',
        ]),

        total(stock) {
            const price = parseFloat(stock.price);
            const quantity = parseFloat(stock.return_quantity);

            if (_.isNaN(price) || _.isNaN(quantity)) return 0;

            return this.formattedNumber(price * quantity);
        },

        onSelectStock(stockInventory) {
            if (this.findStockIndex(stockInventory.stock_id) >= 0) {
                $(`#return_quantity_${stockInventory.stock_id}`).focus();
            } else {
                this.addReturnStock(stockInventory);
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_return/stock-return-edit-stocks.vue